<script>
	import { navBarSize } from '$lib/store/navBarSize.store';
	let className = '';

	export { className as class };
</script>

<!-- Auto Size Adjustment -->
<div class={className} style:height={`${$navBarSize}px`}></div>
